import request from "@/utils/request";

// 首页视频
export function getVideo(data) {
  return request({
    url: `/api/example/C_elsevideo/getList`,
    method: "post",
    data: {
      currentPage: 1,
      dataType: 0,
      menuState: "教学视频",
      pageSize: 20,
      sidx: "",
      sort: "desc",
      superQueryJson: "",
    },
  });
}
// 首页通知公告
export function getBaseBizNoticeList() {
  return request({
    url: `/api/business/baseBizNotice/getList`,
    method: "post",
  });
}
// 联系我们
export function getContactUsInfo() {
  return request({
    url: `/api/business/contactUs/getInfo`,
    method: "get",
  });
}

//核心产品功能
export function checkPerhomeTopMgrmit(data) {
  return request({
    url: `/api/business/homeTopMgr/getList`,
    method: "post",
    data,
  });
}
//产品优势
export function productAdvantage(data) {
  return request({
    url: `/api/business/productAdvantage/getList`,
    method: "post",
    data,
  });
}
//行业分类
export function industryType() {
  return request({
    url: `/api/business/industryType/tree`,
    method: "post",
  });
}
//大类下的小类
export function industryApplications(refId) {
  return request({
    url: `/api/business/industryApplications/getList?refId=${refId}`,
    method: "post",
  });
}